import {
    GET_ROUTES,
    GET_ROUTE,
    SYNC_ROUTES,
} from '../constants/action-types';

// INITIALIZE STATE
const initialState = {
    routes: {},
    route: {},
    instanceId: null,
    statusOutput: null
};

function createRoute(routeId) {
    return { id: routeId };
}

// REDUCER
export const RouteReducer = (state = initialState, action) => {
    switch (action.type) {
        case GET_ROUTES: {
            const routes = {}

            let incomingRoutes = action.payload;

            incomingRoutes.forEach(routeKey => {
                routes[routeKey] = createRoute(routeKey);
            })

            return {
                ...initialState,
                routes
            }
        }

        case GET_ROUTE: {
            // Routes are just strings, so fetch all and check the given key exists
            let routeId = action.payload.routeId
            const routes = {}

            let incomingRoutes = action.payload.routes;

            incomingRoutes.forEach(routeKey => {
                routes[routeKey] = createRoute(routeKey);
            })

            let currentRoute = routes[routeId]

            if (currentRoute == null) {
                currentRoute = null
            }

            return {
                ...initialState,
                route: currentRoute,
                routes
            }
        }

        case SYNC_ROUTES: {
            var existingInstanceId = action.payload.id || action.payload.instanceId
            const success = action.payload.output?.success
            const runtimeStatus = action.payload.runtimeStatus

            const newState = { ...state }

            if (existingInstanceId == null || success) {
                newState.statusOutput = runtimeStatus
                newState.instanceId = null

            } else {
                newState.instanceId = existingInstanceId
                newState.statusOutput = runtimeStatus
            }

            return newState
        }


        default:
            return state;
    }
};